import { GET_DISTRIBUTOR, GET_DISTRIBUTOR_LOADING } from '../constants';

export default {
  [GET_DISTRIBUTOR](state, data) {
    state.item = data;
  },
  [GET_DISTRIBUTOR_LOADING](state, data) {
    state.loading = data;
  }
};
